import { Link } from "react-router-dom";

import styles from "./Header.module.css";

import lockupUrl from "@/assets/wordmark-opshub-white.png";
import { BetaBadge } from "@/components/BetaBadge";
import { MenuIcon, XIcon } from "@/components/icons";
import { SearchBox } from "@/components/SearchBox";
import { UserMenu } from "@/components/UserMenu";
import { ChatWidget } from "@/features/chat/ChatWidget";

interface HeaderProps {
  drawerOpen: boolean;
  onToggleDrawer: () => void;
}

/**
 * The full-width dark-chrome header (prototype .header): the reversed OpsHub
 * lockup on the left (symbol + wordmark, one asset — no text lockup to keep in
 * sync), search centred in the free space, account menu on the right. Below the
 * desktop breakpoint a hamburger appears to toggle the sidebar drawer.
 */
export function Header({ drawerOpen, onToggleDrawer }: HeaderProps) {
  return (
    <header className={styles.header}>
      <button
        type="button"
        className={styles.menuBtn}
        aria-label={drawerOpen ? "Close menu" : "Open menu"}
        aria-expanded={drawerOpen}
        onClick={onToggleDrawer}
      >
        {drawerOpen ? <XIcon /> : <MenuIcon />}
      </button>
      <Link to="/" className={styles.brand}>
        <span className={styles.brandLockup}>
          <img src={lockupUrl} alt="Birzulis OpsHub" />
        </span>
        <BetaBadge />
      </Link>
      <SearchBox />
      <div className={styles.actions}>
        <ChatWidget />
        <UserMenu />
      </div>
    </header>
  );
}
